import { useFormikContext , getIn } from 'formik';
import React  from 'react';
import { FormGroup,Label,Input, Container, Button, Row, Col } from 'reactstrap';
import FormInput from '../Form/FormInput';
import { FormLabel } from '../Form/FormLabel';


const PercentageOrPrice = ({ id }) => {
    const { values, setFieldValue } = useFormikContext();
    const checked = getIn(values, id);
    const setValue = (checked) => {
        setFieldValue(id, checked);
    };
    return <React.Fragment>
        <FormGroup check style={{paddingTop:'15px'}}>
            <Label check>
                <Input type="radio" onChange={() => setValue(!checked)} checked={checked} /> {' '}Percentage

            </Label>
        </FormGroup>
        <FormGroup check>
            <Label check>
                <Input type="radio" onChange={() => setValue(!checked)} checked={!checked} />{' '}Amount
            </Label>
        </FormGroup>
    </React.Fragment>
}

const MarginRow = ({index, margin }) => {
    const { values, setFieldValue } = useFormikContext();
    const up = `marginItems[${index}].usePercent`;
    const usePercentage = getIn(values, up);
    const addItem = () => {

        const newItems = [...values.marginItems, {}]
        setFieldValue('marginItems', newItems);
    }
    const removeItem = (i) => {
        values.marginItems.splice(i,1); 
        
        setFieldValue('marginItems', values.marginItems);
    }

    return <Container> <Row>
        
        <Col>
            <FormInput type='number' id={`marginItems[${index}].minRange`} name={`marginItems[${index}].minRange`} value={values.marginItems[index].minRange} />
        </Col>
        <Col>
            <FormInput type='number' id={`marginItems[${index}].maxRange`} name={`marginItems[${index}].minRange`} value={values.marginItems[index].maxRange}/>
        </Col>
        <Col>
            <PercentageOrPrice id={up} />
        </Col>
        <Col>
            
            {usePercentage ?

                <FormInput id={`marginItems[${index}].percentage`} value={values.marginItems[index].percentage}  type='number'/> :
                <FormInput id={`marginItems[${index}].price`} value={values.marginItems[index].price} type='number'/>}
        </Col>
        <Col>
            <Button onClick={()=>addItem(index)}>+</Button><Button onClick={()=> removeItem(index)}>-</Button>
        </Col>

    </Row>

    </Container>
}

const MarginEditor = () => {
    const { values, setFieldValue } = useFormikContext();
    const addItem = () => {

        const newItems = [...values.marginItems, {}]
        setFieldValue('marginItems', newItems);
    }
    return <React.Fragment><h4> Margin Editor</h4>
        <Container> <Row>
            <Col>
                <FormLabel>Min</FormLabel>
            </Col>
            <Col>
                <FormLabel>Max</FormLabel>
            </Col>
            <Col>
               
            </Col>
            <Col>
                <FormLabel>Margin</FormLabel>
            </Col>
            <Col>
                <FormLabel>Actions</FormLabel>
                {values.marginItems.length ? null : <Button onClick={()=>addItem(0)}>+</Button>}
            </Col>
        </Row>

        </Container>
        {values.marginItems.map((x, i) => <MarginRow key={i} index={i} margin={x} />)}
        </React.Fragment>
}
export default MarginEditor;